// extracted by mini-css-extract-plugin
export default {"TextMessage":"TextMessage_TextMessage__hkXVm"};